import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';

import {displayExportTxtSmall} from '@Selectors/builder/myArmyList/export/displayExportTxtSmall';

import Repeater from '@Utils/Repeater';
import ArmyListUnitExport from './ArmyListUnitExport';
import {ArmyListUnit} from '@Models';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import toast from "react-hot-toast";

interface IArmyListExportDetailProps {
}

const ArmyListExportDetail: React.FC<ArmyListExportDetailProps> = ({name, army, points, armyListUnits, exportTxt}) => {
  const copied = () => toast.success('Copied!')

  return (
    <div className="col-12 col-md-10 offset-md-1">
      <p>{name}</p>
      <p>{army}</p>
      <Repeater data={armyListUnits} indexPrefix='unit'>
        {
          (item: ArmyListUnit) => <ArmyListUnitExport armyListUnit={item} showPoints={true} showDetails={true}/>
        }
      </Repeater>
      <p>{points} pts</p>
      <div className="text-center">
        <CopyToClipboard text={exportTxt} onCopy={() => copied()}>
          <button className="btn btn-age"><i className="fa fa-2x actions fa-copy"/> Copy to clipboard</button>
        </CopyToClipboard>
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArmyListExportDetailProps) => ({
  ...displayExportTxtSmall(state, {...owsProps, showDetails: true})
})

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListExportDetail);

type ArmyListExportDetailProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
